<template>
  <div class="p-postEditor__itemWrapper">
    <div v-show="editingItemIndex !== index" @click="editItem">
      <point-item-preview :item="item" />
    </div>
    <item-form v-if="editingItemIndex === index" :item="item">
      <h3>ポイント</h3>
      <v-text-field
        :value="editingItemable.title"
        :counter="40"
        :rules="[presenceValidation]"
        label="タイトル"
        autofocus
        required
        @input="(value) => updateEditingItemable(value, 'title')"
      />
      <v-textarea
        :value="editingItemable.content"
        class="body-2"
        :counter="200"
        :rules="[presenceValidation]"
        label="テキスト"
        rows="1"
        auto-grow
        @input="(value) => updateEditingItemable(value, 'content')"
      />
    </item-form>
  </div>
</template>

<script>
import itemUtilsMixin from '@/mixins/item_utils'
import PointItemPreview from './previews/PointItemPreview'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  name: 'PointItem',
  components: { PointItemPreview },
  mixins: [itemUtilsMixin, formValidationUtils],
  computed: {
    content: function () {
      return this.item.itemableAttributes.content
    }
  }
}
</script>

<style scoped></style>
